import type { HandlerSpecRow } from '../../api/handlersV2Api';
import type { CreateHandlerPreset } from './CreateHandlerFormV2';

export function formatDate(value: string) {
  if (!value) return '—';
  try {
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return value;
    return d.toLocaleString();
  } catch {
    return value;
  }
}

export function buildPresetFromHandler(row: HandlerSpecRow): CreateHandlerPreset {
  // For now, v2 UI uses the outcome-projected handler_spec as a "template".
  // Create uses latest-by-default (system.handler.create); version is not user-editable in the UI.

  const hk = String(row.handler_key || '').trim();
  const [beforeTag] = hk.includes(':') ? hk.split(':') : [hk];
  const parts = String(beforeTag || '').split('.').filter(Boolean);

  const handler_key_base = row.handler_key_base || (parts.length >= 1 ? (parts[parts.length - 1] ?? '') : '');
  const handler_namespace = row.handler_namespace || (parts.length >= 2 ? (parts[parts.length - 2] ?? '') : '');

  const tags = Array.isArray(row.tags) ? row.tags.join(', ') : '';

  const configJson = row.config && typeof row.config === 'object'
    ? JSON.stringify(row.config, null, 2)
    : '';

  return {
    handler_key: hk,
    worker_id: '',
    handler_namespace,
    handler_key_base,
    description: String(row.description ?? ''),
    timeout_sec: String(row.timeout_sec ?? 300),
    max_retries: String(row.max_retries ?? 3),
    backoff_ms: String(row.backoff_ms ?? 1000),
    priority: String(row.priority ?? 0),
    tags,
    configJson,
    is_active: row.is_active == null ? true : Boolean(row.is_active),
  };
}
